module.exports = __webpack_public_path__ + "static/media/news1.6d624a5e.jpg";